/** Legacy links are permanent moves: replace, so Back does not bounce the user. */
export const REPLACE_HISTORY = true;
